import { Box } from "@mui/material";
import { SxProps } from "@mui/system";
import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import TEST_ID from "enums/TEST_ID";
import { KEYWORD_FILTER } from "features/PanelManagement/components/Filters/FilterComponents/KeywordFilter";
import PanelManagementContext from "features/PanelManagement/context/PanelManagementContext";
import { useContext } from "react";
import { getDataTestProp } from "utils/cypressTesting";

interface Props {
  children?: React.ReactNode;
  includeSearch?: boolean;
  includeFilter?: boolean;
  includeExport?: boolean;
  quickFilterPlaceholder?: string;
  trailing?: React.ReactNode;
  sx?: SxProps;
}

export function CustomToolbar({
  children,
  includeFilter = true,
  includeSearch = true,
  includeExport = true,
  quickFilterPlaceholder,
  trailing,
  sx,
}: Props) {
  const { filterGroupStates } = useContext(PanelManagementContext);
  const keywordFilter = (filterGroupStates[KEYWORD_FILTER]?.filterFieldStates ||
    [])[0];

  return (
    <GridToolbarContainer
      sx={{
        p: 2,
        display: "flex",
        alignItems: "center",
        ...sx,
      }}
    >
      {children}
      {includeSearch && (
        <GridToolbarQuickFilter
          sx={{
            mt: 0,
            pb: 3,
          }}
          inputProps={{
            ...getDataTestProp(TEST_ID.global.searchFilter),
            ...(quickFilterPlaceholder
              ? { placeholder: quickFilterPlaceholder }
              : {}),
          }}
        />
      )}
      {includeFilter && (
        <GridToolbarFilterButton
          sx={({ palette }) => ({
            color: palette.grey[800],
            pb: 3,
          })}
        />
      )}
      {includeExport && (
        <GridToolbarExport
          printOptions={{ disableToolbarButton: true }}
          csvOptions={{
            allColumns: true,
            fileName: `hydra-${keywordFilter ? keywordFilter?.answer : "export"}-${new Date().toLocaleDateString()}`,
          }}
          sx={({ palette }) => ({
            color: palette.grey[800],
            pb: 3,
          })}
        />
      )}
      {trailing && (
        <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
          {trailing}
        </Box>
      )}
    </GridToolbarContainer>
  );
}
